<template>
    <div class="home-hero__scroll absolute w-full flex justify-center" data-scroll-indicator="">
        <span class="home-hero__scroll-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M10.4572 18.258L2.18154 10.212L-5.39093e-07 12.333L12 24L24 12.333L21.8185 10.212L13.5428 18.258L13.5428 5.91975e-07L10.4572 4.57098e-07L10.4572 18.258Z" fill="white"></path>
            </svg>
        </span>
    </div>
</template>

<script>
    export default {
        name: "SectionDownArrow"
    }
</script>

<style scoped>

</style>